export default function Worker_fn() {
  return new Worker("/dist/8.1.1.77/" + "XhrWorker.vbworker.min.worker.js");
}
